jQuery(document).ready(function($) {
    console.log('hello')
    let maxHeight = 0;
    $('.product-list__list .slick-list .product-card').each(function() {
        if($(this).height() > maxHeight) {
            maxHeight = $(this).height();
        }
    });

    $('.product-list__list .slick-list .product-card').height(maxHeight);

    // Product variant toggle modification to handle after clicking 'read more'

    $(document).on('click mouseover', '.product-card__variants-colour', function(e) {
        e.target.parentElement.querySelector('div.product-card__variants-colour.active').classList.remove('active');
        var image = e.target.getAttribute('data-attr-product-image');
        e.target.closest('.product-card').querySelector('.product-card__image a img').setAttribute('src', image);
        e.target.classList.add('active');
    });

    $(document).on('click', '.hamburger-menu.mobile', function() {
        $('.logo').show();
        $('.logo img:not(.pullup-logo)').show().css('z-index', 5);
        $('.logo img.pullup-logo').hide();
    });

    $(document).on('click', '.parent--arrow', function() {
        $('.logo img:not(.pullup-logo)').hide();
        $('.logo img.pullup-logo').hide();
        $('.logo').hide();
    });

    $(document).on('click', '.mega--menu--go--back', function() {
        $('.logo').show();
        $('.logo img:not(.pullup-logo)').show().css('z-index', 5);
        $('.logo img.pullup-logo').hide();
    });

    $(document).on('click', '.product-card', function(e) {
        if(e.target.className == 'wk-icon') {
            return
        } else if (!$(this).hasClass('swatch-clicked')) {
          window.location = $(this).attr('data-href');
        }
    });

    $(document).on('click', '.product-card__variants-colour', function(e) {
        const screenWidth = $(window).width();
        if (screenWidth > 768) {
        return;
        }

        e.preventDefault();
        const $productCard = $(this).closest('.product-card');
        $productCard.find('.product-card__variants-colour.active').removeClass('active');
        $(this).addClass('active');
        const image = $(this).data('attr-product-image');
        $productCard.find('.product-card__image picture source').attr('srcset', image);
        $productCard.addClass('swatch-clicked');
    });


    $(document).on('mouseover', 'header.site-header .navigation nav > ul > li', function() {
        if($(window).width() > 1024) {
            setTimeout(function() {
                $('.mega--menu--wrap').addClass('visible');
            }, 500);
        }
    });



    $(window).on('scroll', function() {

    });

    $(document).on('click', '.cart-drawer__header-close', function() {
        $('.cart-drawer').removeClass('active');
        $('.cart-drawer__inner').removeClass('open');
    });
});
console.log('fish')
